/**
 * One-time localStorage migration from the old working title's key prefix to
 * `callout:`. Imported before anything else so it runs ahead of the modules
 * that read these keys at import time (the settings store). Carries over the
 * session token, callsign, character and settings, so the rename logs nobody
 * out. Safe to delete once every device has launched the renamed build.
 */
try {
  for (const key of ['callsign', 'character', 'settings', 'session']) {
    const legacy = localStorage.getItem(`rivals:${key}`);
    if (legacy !== null) {
      if (localStorage.getItem(`callout:${key}`) === null) {
        localStorage.setItem(`callout:${key}`, legacy);
      }
      localStorage.removeItem(`rivals:${key}`);
    }
  }
} catch {
  // No localStorage (locked-down browser): nothing to migrate.
}
